import React from 'react';
import "./LoanSpinner.scss";
import SpinnerImage from "../assets/images/spinner/ajaxspinner.gif";


class LoanSpinner extends React.Component {
  componentWillMount() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("overflow-hide");
  }
  componentWillUnmount() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("overflow-hide");
  }

  render () {
    return(
      <div className="row justify-content-md-center">
        <div className="col col-lg-12 col-md-12 col-sm-12">
          <div className="spinnerOverlay"></div>
          <img src={SpinnerImage} className="spinner"/>
          <p className="progress-message">Please wait, account Validation is done..</p>
        </div>
      </div>
    );
  }
}

export default LoanSpinner;
